var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import markdownDatasets from "../markdownDatasets";
import PagesContext from "./Context";
import { objectPath } from "../utils";

export class ValueComponent extends Component {
  renderChildren(_value) {
    const { path } = this.props;
    return path ? objectPath(path, _value) : _value;
  }

  render() {
    const { property, value } = this.props;
    return property ?
    this.renderChildren(value) : /*#__PURE__*/

    _jsx(PagesContext.Consumer, {}, void 0, (val) => this.renderChildren(val));

  }
}

ValueComponent.defaultProps = {
  value: '-',
  path: '',
  property: ''
};







export const mapStateToProps = (state, props) =>
props.property ? { value: markdownDatasets.getMetadataValue(state, props) } : {};

export default connect(mapStateToProps)(ValueComponent);